import EmptyPlaceholder from '@orientaction/commons/EmptyPlaceholder';
import style from './style';

const NoResponse = () => {
  const classes = style();
  return <EmptyPlaceholder overrideStyle={classes.root} placeholder="Aucune réponse créée" />;
};

export default NoResponse;
